import React, { useState } from 'react';
import axios from 'axios';
import { useToast } from '../hooks/useToast';

const ForgotPassword = ({ onBack }) => {
  const toast = useToast();
  const [email, setEmail] = useState('');
  const [sent, setSent] = useState(false);
  const [devToken, setDevToken] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.post(`${process.env.REACT_APP_API_URL}/api/auth/forgot-password`, {
        email
      });

      setSent(true);
      toast.success(response.data.message);

      // For development - show the reset token. It stays in the panel below
      // instead of going in the toast: the toast is a single line and would
      // collapse the token into the message text.
      if (response.data.dev_reset_token) {
        setDevToken(response.data.dev_reset_token);
      }
    } catch (error) {
      toast.error(error.response?.data?.error || 'Password reset request failed');
    }

    setLoading(false);
  };

  return (
    <div className="auth-container">
      <div className="auth-card reset-container">
        <div className="auth-logo">SqueakBase</div>
        <p className="auth-subtitle">
          Forgot your password? No worries, we'll send you reset instructions.
        </p>

        {!sent ? (
          <>
            <div className="reset-info">
              <h4>Password Reset</h4>
              <p>
                Enter your email address and we'll send you a link to reset your password.
              </p>
            </div>

            <form onSubmit={handleSubmit} className="auth-form">
              <div className="form-group">
                <label htmlFor="email">
                  Email Address <span className="required">*</span>
                </label>
                <input
                  type="email"
                  id="email"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email address"
                  required
                  autoComplete="email"
                />
                <div className="field-hint">
                  We'll send reset instructions to this email address
                </div>
              </div>

              <button
                type="submit"
                disabled={loading}
                className="auth-button"
              >
                {loading ? (
                  <span className="auth-loading">Sending...</span>
                ) : (
                  'Send Reset Instructions'
                )}
              </button>
            </form>

            <div className="auth-divider">
              <span>or</span>
            </div>

            <button
              type="button"
              onClick={onBack}
              className="auth-button outline"
            >
              Back to Sign In
            </button>
          </>
        ) : (
          <>
            {devToken && (
              <div className="success" style={{ whiteSpace: 'pre-line' }}>
                DEV MODE - Reset token: {devToken}
              </div>
            )}

            <div className="reset-info">
              <h4>Check Your Email</h4>
              <p>
                If an account with that email exists, we've sent you password reset instructions.
                Please check your email and follow the link to reset your password.
              </p>
            </div>

            <button
              onClick={onBack}
              className="auth-button"
            >
              Back to Sign In
            </button>

            <div className="auth-footer">
              <p className="field-hint">
                Didn't receive the email? Check your spam folder or try again with a different email address.
              </p>
            </div>
          </>
        )}
      </div>
    </div>
  );
};

export default ForgotPassword;
